/* istanbul ignore file */
export * from './EcoLabelCard';
